import React from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import './title-description.scss';
import ListingStatus from '../listing-status/listing-status';
import Tooltip from '../tooltip/tooltip';

export default function TitleDescription({
  title,
  description,
  renderDescription,
  tag,
  redireUrl,
  className,
  descriptionLimit,
  accessor,
}) {
  const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
      return `${text.slice(0, maxLength)}...`;
    }
    return text;
  };

  const getContent = () => {
    if (renderDescription) {
      return renderDescription;
    }

    if (description) {
      return (
        <Tooltip content={description} className="tooltip-maxcontent">
          {ReactHtmlParser(truncateText(description, descriptionLimit))}
        </Tooltip>
      );
    }

    return '--';
  };

  return (
    <div className={`title-description-container ${className}`}>
      <h4 className="title" data-cy="my-company-title">
        {title}
      </h4>

      {tag ? (
        <p className="description">
          <span className="paragraph">{description}</span>
        </p>
      ) : (
        <>
          {title !== 'Status' && accessor !== 'currentStatus' && redireUrl ? (
            <p className="description">
              <Link to={redireUrl}>{getContent()}</Link>
            </p>
          ) : null}

          {title !== 'Status' && accessor !== 'currentStatus' && !redireUrl && (
            <div className="description" data-cy="my-company-description">
              {getContent()}
            </div>
          )}

          {(title === 'Status' || accessor === 'currentStatus') && (
            <ListingStatus statusLabel={description} autoWidth />
          )}

          <span />
        </>
      )}
    </div>
  );
}

TitleDescription.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  renderDescription: PropTypes.node,
  tag: PropTypes.bool,
  redireUrl: PropTypes.string,
  className: PropTypes.string,
  descriptionLimit: PropTypes.number,
  accessor: PropTypes.string,
};

TitleDescription.defaultProps = {
  title: 'Title',
  description: '--',
  renderDescription: null,
  tag: false,
  redireUrl: '',
  className: '',
  descriptionLimit: 20,
  accessor: '',
};
